import { ColumnDef } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { Product } from '~/shared/api'
import { Status } from '../model/types'
import { ArrowToDownTable } from '~/shared/ui/table/ui'
import ImageWithFallback from '~/shared/ui/image-with-fallback'
import { PrintBarcodeModalButton } from '~/shared/ui/print-barcode-modal-button'

export const PRODUCTS_STORAGE_FILTER_KEY = 'productsFilters'
export const PRODUCTS_STORAGE_FILTER_PARAMS_STR = 'productsFiltersQueryString'

export const PRODUCTS_STATUSES: Status[] = [
  { label: 'Активен', value: 'true' },
  { label: 'Отключен', value: 'false' },
]

export const PRODUCTS_TABLE_CONFIG: ColumnDef<Product>[] = [
  {
    header: '',
    accessorKey: 'spoiler',

    cell: (row) => {
      return (
        <ArrowToDownTable
          id={row.cell.row.original.id}
          storeName="productsStore"
        />
      )
    },
    maxSize: 5,
  },
  {
    header: 'image',
    accessorKey: 'image',

    cell: (row) => {
      const { original } = row.cell.row

      const imageSrc =
        original?.images?.first?.c300 ??
        original?.images?.first?.original ??
        null

      return (
        <div className="w-16 h-16 rounded shadow">
          <Link to={`/products/${original.id}/edit`}>
            <ImageWithFallback
              className="w-full h-full object-contain rounded"
              src={imageSrc}
              alt="Product Thumbnail"
            />
          </Link>
        </div>
      )
    },
    maxSize: 70,
  },
  {
    header: 'name',
    accessorKey: 'name',

    cell: (row) => {
      const { original } = row.cell.row

      return (
        <Link
          to={`/products/${original.id}/edit`}
          className="truncate w-full block"
        >
          {original?.name}
        </Link>
      )
    },
    maxSize: 150,
  },
  {
    header: '',
    accessorKey: 'print',

    cell: (row) => {
      const { original } = row.cell.row

      return <PrintBarcodeModalButton id={original.id} />
    },
    maxSize: 40,
  },

  {
    header: 'price',
    accessorKey: 'priceString',
    cell: (row) => {
      const { original } = row.cell.row

      return (
        <Link to={`/products/${original.id}/edit`}>
          {row.cell.row.original.priceString}
        </Link>
      )
    },
    maxSize: 150,
  },
  {
    header: 'manufacturer',
    accessorKey: 'manufacturer',

    cell: (row) => {
      const { original } = row.cell.row

      return (
        <Link to={`/products/${original.id}/edit`}>
          {row.cell.row.original?.manufacturer?.name}
        </Link>
      )
    },
    maxSize: 150,
  },
]
